var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('collection-list-link',{attrs:{"listLayout":_vm.listLayout,"paginationData":_vm.filterSet.page,"collectionData":_vm.List}}),(_vm.filterSet.page.total)?_c('pagination-link',{attrs:{"paginationLayout":_vm.paginationLayout,"paginationData":_vm.filterSet.page,"listLength":_vm.List.length,"finishGetList":_vm.finishGetList}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }